export type TableTranslations = {
  content: {
    button: {
      clear: string;
      hideFilters: string;
      manageColumns: string;
      search: string;
      showFilters: string;
      tour: string;
    };
    maxRows: string;
    nextPage: string;
    noResults: string;
    of: string;
    previousPage: string;
  };
};

export const tableTranslations: TableTranslations = {
  content: {
    button: {
      clear: 'Clear',
      hideFilters: 'Hide filters',
      manageColumns: 'Manage columns',
      search: 'Search',
      showFilters: 'Show filters',
      tour: 'Help',
    },
    maxRows: 'Max rows',
    nextPage: 'Next page',
    noResults: 'No results',
    of: 'of',
    previousPage: 'Previous page',
  },
};
